/**
 * SweetAlert2 helpers – use these instead of alert() / confirm()
 */
import Swal from 'sweetalert2';

export default Swal;

export const toast = (message, icon = 'success') => {
  return Swal.fire({
    toast: true,
    position: 'top-end',
    icon,
    title: message,
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });
};

export const alertSuccess = (title, text) => {
  return Swal.fire({ title: title || 'Success', text: text || '', icon: 'success' });
};

export const alertError = (title, text) => {
  return Swal.fire({ title: title || 'Error', text: text || 'Something went wrong.', icon: 'error' });
};

export const confirmDelete = (options = {}) => {
  const { title = 'Are you sure?', text = 'This action cannot be undone.', confirmButtonText = 'Yes, delete' } = options;
  return Swal.fire({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#e53e3e',
    cancelButtonColor: '#718096',
    confirmButtonText,
    cancelButtonText: 'Cancel',
  }).then((result) => ({ isConfirmed: result.isConfirmed }));
};
